const de = {
    _name: 'Deutsch',
    _flag: '🇩🇪',
    // Nav
    'nav.dashboard': 'Dashboard',
    'nav.pos': 'Verkaufsstelle',
    'nav.calcul': 'Preisberechnung',
    'nav.devis': 'Angebote / Rechnungen',
    'nav.devisDeplacement': 'Vor-Ort-Angebote',
    'nav.commandes': 'Bestellungen',
    'nav.addDevice': 'Gerät hinzufügen',
    'nav.reparations': 'Reparaturen',
    'nav.clients': 'Kunden',
    'nav.stock': 'Lager',
    'nav.addStock': 'Lager hinzufügen',
    'nav.etiquettes': 'Etiketten',
    'nav.users': 'Benutzer',
    'nav.clientPwd': 'Kunden-Passwörter',
    'nav.boutiqueOrders': 'Shop-Bestellungen',
    'nav.caisseHistory': 'Kassenhistorie',
    'nav.database': 'Datenbank',
    'nav.historique': 'Verlauf',
    'nav.paiements': 'Online-Zahlungen',
    'nav.chatClients': 'Kunden-Chat',
    'nav.chat': 'Nachrichten',
    'nav.notes': 'Notizen',
    'nav.logout': 'Abmelden',
    'nav.quit': 'Beenden',
    'nav.admin': 'Verwaltung',
    'nav.navigation': 'Navigation',
    'nav.b2b': 'B2B-Verwaltung',
    'nav.b2bPayments': 'B2B-Zahlungen',
    'nav.brandsModels': 'Marken & Modelle',
    // Common
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.delete': 'Löschen',
    'common.edit': 'Bearbeiten',
    'common.search': 'Suchen',
    'common.add': 'Hinzufügen',
    'common.close': 'Schließen',
    'common.confirm': 'Bestätigen',
    'common.loading': 'Laden...',
    'common.noData': 'Keine Daten',
    'common.actions': 'Aktionen',
    'common.status': 'Status',
    'common.date': 'Datum',
    'common.total': 'Gesamt',
    'common.print': 'Drucken',
    'common.yes': 'Ja',
    'common.no': 'Nein',
    'common.back': 'Zurück',
    'common.next': 'Weiter',
    'common.validate': 'Bestätigen',
    'common.ref': 'Referenz',
    'common.client': 'Kunde',
    'common.phone': 'Telefon',
    'common.email': 'E-Mail',
    'common.price': 'Preis',
    'common.quantity': 'Menge',
    'common.amount': 'Betrag',
    'common.send': 'Senden',
    'common.download': 'Herunterladen',
    'common.export': 'Exportieren',
    'common.refresh': 'Aktualisieren',
    'common.filter': 'Filtern',
    'common.all': 'Alle',
    'common.name': 'Name',
    'common.address': 'Adresse',
    'common.description': 'Beschreibung',
    'common.payment': 'Zahlung',
    'common.paid': 'Bezahlt',
    'common.pending': 'Ausstehend',
    'common.accepted': 'Akzeptiert',
    'common.refused': 'Abgelehnt',
    // Layout
    'layout.panel': 'Verwaltungspanel',
    // POS
    'pos.title': 'Verkaufsstelle',
    'pos.scanner': 'Scanner',
    'pos.searchProduct': 'Produkt suchen (Ref, Name, Barcode)...',
    'pos.outOfStock': 'Nicht vorrätig',
    'pos.article': 'Artikel',
    'pos.unitPrice': 'Stückpreis',
    'pos.qty': 'Menge',
    'pos.emptyCart': 'Warenkorb leer',
    'pos.checkout': 'Kassieren',
    'pos.clientOptional': 'Kunde (optional)',
    'pos.discount': 'Rabatt',
    'pos.subtotal': 'Zwischensumme',
    'pos.validateSale': 'Verkauf bestätigen',
    'pos.paymentMode': 'Zahlungsart',
    'pos.choosePayment': 'Zahlungsart wählen:',
    'pos.cash': 'Bargeld',
    'pos.card': 'Kreditkarte',
    'pos.mixed': 'Gemischt',
    'pos.totalToCollect': 'Zu kassierender Betrag',
    'pos.change': 'Wechselgeld',
    'pos.confirmPayment': 'Zahlung bestätigen',
    'pos.validating': 'Bestätigung...',
    'pos.lastTicket': 'Letzter Kassenbon',
    'pos.caisseClosed': 'Die Kasse ist geschlossen. Bitte öffnen Sie sie vom Dashboard, um Verkäufe durchzuführen.',
    'pos.insufficientCash': 'Unzureichender Bargeldbetrag',
    'pos.insufficientCard': 'Unzureichender Kartenbetrag',
    'pos.mixedMustEqual': 'Die gemischte Zahlung muss dem Gesamtbetrag entsprechen',
    'pos.emptyCartAlert': 'Warenkorb leer',
    'pos.selectPayment': 'Bitte wählen Sie eine Zahlungsart',
    'pos.saleValidated': 'Verkauf bestätigt!',
    'pos.adminOverride': 'Administrator-Freigabe',
    'pos.outOfStockProduct': 'Nicht vorrätiges Produkt',
    'pos.adminId': 'Admin-Kennung',
    'pos.adminCode': 'Admin-Code',
    'pos.manualAdd': 'Nicht vorrätigen Artikel hinzufügen',
    'pos.designation': 'Bezeichnung',
    'pos.stockInsufficient': 'Lagerbestand unzureichend',
    // Devis
    'devis.title': 'Angebote & Rechnungen',
    'devis.subtitle': 'Dokumente aus der Preisberechnung (in Bestellung umwandelbar).',
    'devis.noDoc': 'Keine Dokumente gefunden',
    'devis.type': 'Typ',
    'devis.convertConfirm': 'Dieses Angebot in eine Bestellung umwandeln?',
    'devis.orderCreated': 'Bestellung erstellt',
    'devis.deleteConfirm': 'Dieses Dokument löschen?',
    'devis.deleted': 'Dokument gelöscht',
    // Devis Déplacement
    'devDep.title': 'Vor-Ort-Angebote',
    'devDep.subtitle': 'Verwaltung von Angeboten für Reparaturen vor Ort',
    'devDep.new': 'Neues Angebot',
    'devDep.edit': 'Angebot bearbeiten',
    'devDep.clientName': 'Kundenname',
    'devDep.clientPhone': 'Telefon',
    'devDep.clientEmail': 'E-Mail',
    'devDep.clientAddress': 'Adresse',
    'devDep.repairDesc': 'Reparaturbeschreibung',
    'devDep.lines': 'Angebotszeilen',
    'devDep.addLine': 'Hinzufügen',
    'devDep.travelFee': 'Anfahrtskosten',
    'devDep.sendByEmail': 'Per E-Mail senden',
    'devDep.sending': 'Wird gesendet...',
    'devDep.pdfDevis': 'PDF Angebot',
    'devDep.pdfBon': 'PDF Bestellschein',
    'devDep.pdfFacture': 'PDF Rechnung',
    'devDep.searchPlaceholder': 'Suche nach Ref, Name, E-Mail...',
    'devDep.allStatuses': 'Alle Status',
    'devDep.pending': 'Ausstehend',
    'devDep.accepted': 'Akzeptiert',
    'devDep.refused': 'Abgelehnt',
    'devDep.depositPaid': 'Anzahlung geleistet',
    'devDep.fullyPaid': 'Bezahlt',
    'devDep.stats': 'Statistiken',
    'devDep.revenues': 'Einnahmen',
    'devDep.activity30d': 'Aktivität der letzten 30 Tage',
    'devDep.remind': 'Erinnerung senden',
    'devDep.remindConfirm': 'Erinnerung an Kunden mit seit mehr als 3 Tagen ausstehenden Angeboten senden?',
    'devDep.noDevis': 'Keine Angebote erstellt',
    'devDep.noResults': 'Keine Ergebnisse',
    'devDep.bon': 'Bestellschein',
    'devDep.facture': 'Rechnung',
    'devDep.emailSent': 'E-Mail gesendet am',
    'devDep.reminderSent': 'Erinnerung gesendet am',
    // Reparations
    'rep.title': 'Reparaturen',
    'rep.search': 'Reparatur suchen...',
    'rep.new': 'Neue Reparatur',
    'rep.deviceRef': 'Geräte-Ref.',
    'rep.brand': 'Marke',
    'rep.model': 'Modell',
    'rep.problem': 'Problem',
    'rep.technician': 'Techniker',
    'rep.timeline': 'Zeitverlauf',
    // Commandes
    'cmd.title': 'Bestellungen',
    'cmd.search': 'Bestellung suchen...',
    'cmd.piece': 'Teil',
    'cmd.supplier': 'Lieferant',
    'cmd.deposit': 'Anzahlung',
    'cmd.remaining': 'Restbetrag',
    // Clients
    'clients.title': 'Kunden',
    'clients.search': 'Kunde suchen...',
    'clients.name': 'Name',
    'clients.address': 'Adresse',
    'clients.addClient': 'Neuer Kunde',
    // Stock
    'stock.title': 'Lagerverwaltung',
    'stock.search': 'Artikel suchen...',
    'stock.addArticle': 'Artikel hinzufügen',
    'stock.category': 'Kategorie',
    'stock.buyPrice': 'Einkaufspreis',
    'stock.sellPrice': 'Verkaufspreis',
    'stock.available': 'Verfügbar',
    // Dashboard
    'dash.title': 'Dashboard',
    'dash.openCaisse': 'Kasse öffnen',
    'dash.closeCaisse': 'Kasse schließen',
    'dash.todaySales': 'Verkäufe heute',
    'dash.monthSales': 'Verkäufe des Monats',
    'dash.activeRepairs': 'Aktive Reparaturen',
    'dash.pendingOrders': 'Ausstehende Bestellungen',
    // Login
    'login.title': 'Anmeldung',
    'login.username': 'Benutzername',
    'login.password': 'Zugangscode',
    'login.submit': 'Anmelden',
    'login.clientAccess': 'Kundenzugang',
    'login.staffAccess': 'Personalzugang',
    // Language
    'lang.select': 'Sprache',
    // Client Portal
    'client.space': 'Kundenbereich',
    'client.repairs': 'Reparaturen',
    'client.boutique': 'Shop',
    'client.orders': 'Bestellungen',
    'client.messages': 'Nachrichten',
    'client.devis': 'Angebote',
    'client.trackRepairs': 'Ihre Reparaturen verfolgen',
    'client.noRepairs': 'Keine laufenden Reparaturen',
    'client.trackOrders': 'Ihre Bestellungen verfolgen',
    'client.noOrders': 'Keine laufenden Bestellungen',
    'client.shop': 'Online-Shop',
    'client.noProducts': 'Keine Produkte verfügbar',
    'client.addToCart': 'In den Warenkorb',
    'client.yourMessages': 'Ihre Nachrichten',
    'client.noMessages': 'Keine Nachrichten',
    'client.send': 'Senden',
    'client.brand': 'Marke',
    'client.model': 'Modell',
    'client.problem': 'Problem',
    'client.status': 'Status',
    'client.deposit': 'Anzahlung',
    'client.remaining': 'Restbetrag',
    'client.total': 'Gesamt',
    'client.timeline': 'Zeitverlauf',
    'client.noDevis': 'Noch keine Angebote',
    'client.acceptRefuse': 'Akzeptieren / Ablehnen',
    'client.pay': 'Bezahlen',
    // Landing
    'landing.mobileRepair': 'Handy-Reparatur in Französisch-Guayana',
    'landing.staffSpace': 'PERSONALBEREICH',
    'landing.staffDesc': 'Zugang für das technische Team',
    'landing.clientSpace': 'KUNDENBEREICH',
    'landing.clientDesc': 'Reparaturverfolgung',
    'landing.businessSpace': 'UNTERNEHMENSBEREICH',
    'landing.businessDesc': 'B2B-Portal',
    'landing.contact': 'Kontakt',
    'landing.callWhatsapp': 'Anruf & WhatsApp',
    'landing.writeUs': 'Schreiben Sie uns direkt',
    'landing.hours': 'Öffnungszeiten',
    'landing.legal': 'Rechtliche Informationen',
    'landing.capital': 'mit einem Kapital von',
    'landing.headquarters': 'Hauptsitz',
    'landing.allRights': 'Alle Rechte vorbehalten',
    'landing.heroSubtitle': 'Ihr Spezialist für Handy-Reparatur in Französisch-Guayana',
    'landing.mondayFriday': 'Montag - Freitag',
    'landing.saturday': 'Samstag',
    'landing.sunday': 'Sonntag',
    'landing.closed': 'Geschlossen',
    'landing.companyType': 'Vereinfachte Aktiengesellschaft (SAS)',
    'landing.openMaps': 'In Maps öffnen',
    'landing.rcs': 'HRB',
    'landing.siret': 'SIRET',
    'landing.euid': 'EUID',
    'landing.shopAddress': 'Verkaufsstelle',
    // Login extra
    'login.clientSpace': 'Kundenbereich',
    'login.businessSpace': 'Unternehmensbereich',
    'login.staffSpace': 'Personalbereich',
    'login.connectYou': 'Anmelden',
    'login.phoneNumber': 'Telefonnummer',
    'login.proEmail': 'Geschäftliche E-Mail',
    'login.pin': 'PIN-Code (4 oder 6 Ziffern)',
    'login.pinHint': 'Geben Sie Ihren Code über die Tastatur oder den Ziffernblock ein.',
    'login.connecting': 'Verbindung...',
    'login.connect': 'Anmelden',
    'login.noAccount': 'Noch kein Konto?',
    'login.createAccount': 'Konto erstellen',
    'login.forgotPwd': 'Passwort vergessen?',
    'login.notRegistered': 'Noch nicht registriert?',
    'login.businessRegister': 'Unternehmensregistrierung',
    'login.secure': 'Sichere Anmeldung',
    'login.caricature': 'Meine Karikatur erstellen',
    'login.backHome': 'Zurück zur Startseite',
    'login.wrongCredentials': 'Falsche Anmeldedaten',
    'login.pinError': 'Der PIN-Code muss 4 oder 6 Ziffern enthalten',
    'login.b2bPassword': 'Passwort',
    'login.b2bPlaceholder': 'Ihr Passwort',
    'login.yourId': 'Ihre Kennung',
    // Dashboard extra
    'dash.hello': 'Hallo',
    'dash.loggedAs': 'Angemeldet als',
    'dash.caisseOpen': 'Kasse geöffnet',
    'dash.closeCaisseReminder': 'Denken Sie daran, die Kasse zu schließen',
    'dash.noCaisse': 'Keine Kasse geöffnet',
    'dash.openCaisseTitle': 'Kasse öffnen',
    'dash.openTotal': 'Eröffnungsbetrag',
    'dash.opening': 'Öffnung...',
    'dash.open': 'Öffnen',
    'dash.searchPlaceholder': 'Nach Referenz, Kunde, Telefon suchen...',
    'dash.noResults': 'Keine Ergebnisse gefunden',
    'dash.today': 'Heute',
    'dash.thisMonth': 'Dieser Monat',
    'dash.completed': 'Abgeschlossen',
    'dash.repairsSub': 'Reparaturen',
    'dash.inProgress': 'In Bearbeitung',
    'dash.waitingParts': 'auf Teile wartend inkl.',
    'dash.registeredMonth': 'diesen Monat registriert',
    'dash.statsTitle': 'Statistiken & Analysen',
    'dash.statsDesc': 'Umsatz, Reparaturen, B2B, Kunden',
    'dash.brandsModelsLabel': 'Marken & Modelle',
    'dash.brandsModelsDesc': 'Gerätekatalog verwalten',
    'dash.b2bPaymentsLabel': 'B2B-Zahlungen',
    'dash.b2bPaymentsDesc': 'Rechnungs- und Zahlungsverfolgung',
    'dash.stockAlerts': 'Lageralarme',
    'dash.lowStock': 'Produkte mit niedrigem Lagerbestand',
    'dash.outOfStock': 'nicht vorrätig',
    'dash.recentRepairs': 'Letzte Reparaturen',
    'dash.noClient': 'Ohne Kunde',
    'dash.unclosedTitle': 'Kasse nicht geschlossen',
    'dash.unclosedNotClosed': 'wurde nicht geschlossen',
    'dash.contactAdmin': 'Bitte kontaktieren Sie einen Administrator, um sie zu schließen, bevor Sie fortfahren.',
    'dash.mustClose': 'Sie müssen sie schließen, bevor Sie weiterarbeiten können.',
    'dash.forceClose': 'Erzwungene Schließung',
    'dash.closing': 'Schließung...',
    'dash.closeNormal': 'Normal schließen',
    'dash.noCaisseToday': 'Heute ist keine Kasse geöffnet.',
    'dash.openQuestion': 'Möchten Sie die Kasse jetzt öffnen?',
    'dash.dontOpen': 'Nicht öffnen (fortfahren)',
    'dash.salesBlocked': 'Verkäufe sind blockiert, solange die Kasse nicht geöffnet ist.',
    'dash.calculation': 'Berechnung',
    'dash.repairs': 'Reparaturen',
    'dash.addDevice': 'Hinzufügen',
    'dash.clients': 'Kunden',
    'dash.openedBy': 'geöffnet von',
    'dash.unknown': 'unbekannt',
    'dash.forceCloseConfirm': 'Kasse erzwungen schließen vom',
    'dash.errorForceClose': 'Fehler beim erzwungenen Schließen',
    'dash.errorOpenCaisse': 'Fehler beim Öffnen der Kasse',
    // Devis Accept
    'devisAccept.error': 'Fehler',
    'devisAccept.notFound': 'Angebot nicht gefunden',
    'devisAccept.refused': 'Angebot abgelehnt',
    'devisAccept.refusedMsg': 'Sie haben das Angebot abgelehnt',
    'devisAccept.thanks': 'Vielen Dank für Ihre Rückmeldung.',
    'devisAccept.accepted': 'Angebot akzeptiert!',
    'devisAccept.acceptedMsg': 'Vielen Dank für die Annahme des Angebots',
    'devisAccept.bonCommande': 'Bestellschein',
    'devisAccept.facture': 'Rechnung',
    'devisAccept.emailSent': 'Eine E-Mail mit Ihrem Bestellschein, dem Bestätigungscode und Ihren Anmeldedaten wurde gesendet.',
    'devisAccept.proceedPayment': 'Zur Zahlung',
    'devisAccept.paymentMsg': 'Um Ihre Bestellung abzuschließen, leisten Sie bitte eine Anzahlung oder die vollständige Zahlung:',
    'devisAccept.deposit50': 'Anzahlung 50%',
    'devisAccept.fullPayment': 'Vollständige Zahlung',
    'devisAccept.alreadyAccepted': 'Dieses Angebot wurde bereits akzeptiert.',
    'devisAccept.alreadyRefused': 'Dieses Angebot wurde abgelehnt.',
    'devisAccept.statusMsg': 'Angebotsstatus',
    'devisAccept.payDeposit': 'Anzahlung 50% bezahlen',
    'devisAccept.homeRepairQuote': 'Vor-Ort-Reparaturangebot',
    'devisAccept.hello': 'Hallo',
    'devisAccept.findBelow': 'Nachfolgend finden Sie die Details Ihres Angebots:',
    'devisAccept.designation': 'Bezeichnung',
    'devisAccept.travelFee': 'Anfahrtskosten',
    'devisAccept.tvaNote': 'MwSt. nicht anwendbar, Art. 293B CGI. Angebot 30 Tage gültig.',
    'devisAccept.refuse': 'Ablehnen',
    'devisAccept.accept': 'Angebot akzeptieren',
    'devisAccept.confirmRefuse': 'Sind Sie sicher, dass Sie dieses Angebot ablehnen möchten?',
    // Payment
    'payment.secure': 'Sichere Zahlung',
    'payment.error': 'Fehler',
    'payment.backToDevis': 'Zurück zum Angebot',
    'payment.notAccepted': 'Angebot nicht akzeptiert',
    'payment.mustAcceptFirst': 'Sie müssen zuerst das Angebot akzeptieren, bevor Sie zur Zahlung übergehen können.',
    'payment.viewDevis': 'Angebot ansehen',
    'payment.fullyPaid': 'Rechnung vollständig bezahlt',
    'payment.alreadyPaid': 'ist bereits vollständig bezahlt.',
    'payment.accessClient': 'Zugang zu Ihrem Kundenbereich',
    'payment.deposit50': 'Anzahlung 50%',
    'payment.fullPayment': 'Vollständige Zahlung',
    'payment.devis': 'Angebot',
    'payment.client': 'Kunde',
    'payment.totalDevis': 'Angebotssumme',
    'payment.alreadyPaidAmount': 'Bereits bezahlt',
    'payment.remaining': 'Restbetrag',
    'payment.depositPercent': 'Anzahlung (50%)',
    'payment.amountToPay': 'Zu zahlender Betrag',
    'payment.pay': 'Bezahlen',
    'payment.redirecting': 'Weiterleitung zu Stripe...',
    'payment.securedBy': 'Sichere Zahlung über Stripe',
    'payment.urlNotAvailable': 'Zahlungs-URL nicht verfügbar',
    'payment.creationError': 'Fehler bei der Zahlungserstellung',
    // Payment success
    'paySuccess.confirmed': 'Zahlung bestätigt!',
    'paySuccess.paymentFor': 'Ihre Zahlung für das Angebot',
    'paySuccess.registered': 'wurde erfolgreich registriert.',
    'paySuccess.depositRegistered': 'Anzahlung registriert!',
    'paySuccess.depositFor': 'Ihre Anzahlung für das Angebot',
    'paySuccess.depositDone': 'wurde registriert.',
    'paySuccess.checking': 'Überprüfung läuft...',
    'paySuccess.pleaseWait': 'Wir überprüfen Ihre Zahlung, bitte warten.',
    'paySuccess.waitingConfirm': 'Warte auf Bestätigung',
    'paySuccess.processing': 'Ihre Zahlung wird verarbeitet. Sie erhalten eine Bestätigungs-E-Mail.',
    'paySuccess.totalInvoice': 'Rechnungssumme',
    'paySuccess.amountPaid': 'Bezahlter Betrag',
    'paySuccess.remaining': 'Restbetrag',
    'paySuccess.payRemaining': 'Rest bezahlen',
    'paySuccess.loginClient': 'Melden Sie sich in Ihrem Kundenbereich an',
    // Registration
    'register.clientTitle': 'Kundenkonto erstellen',
    'register.fullName': 'Vollständiger Name',
    'register.phone': 'Telefon',
    'register.email': 'E-Mail (optional)',
    'register.address': 'Adresse (optional)',
    'register.pin': 'PIN-Code (4 oder 6 Ziffern)',
    'register.confirmPin': 'PIN-Code bestätigen',
    'register.creating': 'Wird erstellt...',
    'register.createAccount': 'Mein Konto erstellen',
    'register.alreadyAccount': 'Bereits ein Konto?',
    'register.login': 'Anmelden',
    'register.backHome': 'Zurück zur Startseite',
    'register.pinError': 'Der PIN-Code muss 4 oder 6 Ziffern enthalten',
    'register.pinNoMatch': 'Die PIN-Codes stimmen nicht überein',
    'register.pinMinLength': 'Der PIN-Code muss mindestens 4 Ziffern enthalten',
    // B2B Registration
    'b2bRegister.title': 'Unternehmensregistrierung',
    'b2bRegister.subtitle': 'Erstellen Sie Ihr Geschäftskonto',
    'b2bRegister.companyName': 'Firmenname',
    'b2bRegister.managerName': 'Name des Geschäftsführers',
    'b2bRegister.proEmail': 'Geschäftliche E-Mail',
    'b2bRegister.phone': 'Telefon',
    'b2bRegister.address': 'Adresse',
    'b2bRegister.siret': 'SIRET',
    'b2bRegister.password': 'Passwort',
    'b2bRegister.confirmPassword': 'Passwort bestätigen',
    'b2bRegister.kbis': 'KBIS-Auszug (PDF)',
    'b2bRegister.kbisDesc': 'Laden Sie Ihren KBIS-Auszug oder ein Nachweisdokument hoch (PDF)',
    'b2bRegister.dropFile': 'Klicken oder ziehen Sie Ihre Datei hierher',
    'b2bRegister.creating': 'Registrierung läuft...',
    'b2bRegister.submit': 'Registrieren',
    'b2bRegister.success': 'Registrierung erfolgreich!',
    'b2bRegister.successMsg': 'Ihr Geschäftskonto wird überprüft. Sie erhalten eine Bestätigungs-E-Mail.',
    'b2bRegister.goLogin': 'Zur Anmeldung',
    'b2bRegister.fillAll': 'Bitte füllen Sie alle Pflichtfelder aus',
    'b2bRegister.siretError': 'Die SIRET muss 14 Ziffern enthalten',
    'b2bRegister.pwdNoMatch': 'Die Passwörter stimmen nicht überein',
    'b2bRegister.pwdMinLength': 'Das Passwort muss mindestens 6 Zeichen enthalten',
    'b2bRegister.kbisRequired': 'Bitte laden Sie Ihren KBIS-Auszug hoch',
    'b2bRegister.alreadyAccount': 'Bereits registriert?',
    // Reset password
    'reset.forgotTitle': 'Passwort vergessen',
    'reset.forgotDesc': 'Erhalten Sie einen Reset-Link per E-Mail',
    'reset.enterEmail': 'Bitte geben Sie Ihre E-Mail ein',
    'reset.emailSent': 'E-Mail gesendet',
    'reset.emailSentMsg': 'Wenn ein Konto mit dieser Adresse existiert, erhalten Sie eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts.',
    'reset.linkValid': 'Der Link ist 1 Stunde gültig.',
    'reset.backLogin': 'Zurück zur Anmeldung',
    'reset.clientEmail': 'E-Mail-Adresse Ihres Kontos',
    'reset.sending': 'Wird gesendet...',
    'reset.sendLink': 'Reset-Link senden',
    'reset.newPwdTitle': 'Neues Passwort',
    'reset.newPwdDesc': 'Wählen Sie Ihr neues Passwort',
    'reset.newPwd': 'Neues Passwort',
    'reset.confirmPwd': 'Passwort bestätigen',
    'reset.resetting': 'Zurücksetzung...',
    'reset.resetPwd': 'Passwort zurücksetzen',
    'reset.pwdReset': 'Passwort zurückgesetzt',
    'reset.pwdResetMsg': 'Ihr Passwort wurde erfolgreich geändert.',
    'reset.pwdMinLength': 'Das Passwort muss mindestens 4 Zeichen enthalten',
    'reset.pwdNoMatch': 'Die Passwörter stimmen nicht überein',
    'reset.error': 'Ein Fehler ist aufgetreten',
    // B2B Dashboard
    'b2b.welcome': 'Willkommen',
    'b2b.newRepair': 'Neue Reparatur',
    'b2b.registerDevice': 'Gerät registrieren',
    'b2b.myRepairs': 'Meine Reparaturen',
    'b2b.viewAll': 'Alle Reparaturen ansehen',
    'b2b.recentRepairs': 'Letzte Reparaturen',
    'b2b.noRepairs': 'Keine Reparaturen',
    'b2b.repairRegistered': 'Reparatur registriert',
    'b2b.reference': 'Referenz',
    'b2b.viewDetails': 'Details ansehen',
    'b2b.anotherRepair': 'Neue Reparatur',
    'b2b.deviceInfo': 'Geräteinformationen',
    'b2b.brand': 'Marke',
    'b2b.model': 'Modell',
    'b2b.backGlass': 'Rückglas',
    'b2b.backGlassBroken': 'Rückglas gebrochen',
    'b2b.backGlassOk': 'Rückglas intakt',
    'b2b.providePart': 'Ich stelle das Teil bereit',
    'b2b.partByShop': 'Das Teil wird von R.E.Mobiles bereitgestellt',
    'b2b.lockCode': 'Entsperrcode',
    'b2b.lockTypeCode': 'Code (Zahlen/Buchstaben)',
    'b2b.lockTypeSchema': 'Muster',
    'b2b.problem': 'Problem / Beschreibung',
    'b2b.brokenParts': 'Defekte Teile',
    'b2b.deliveryMethod': 'Liefermethode',
    'b2b.inStore': 'Im Geschäft',
    'b2b.inStoreDesc': 'Abgabe im Geschäft',
    'b2b.postal': 'Postversand',
    'b2b.postalDesc': 'Mit Sendungsverfolgung',
    'b2b.pickup': 'Abholung',
    'b2b.pickupDesc': 'Wir holen es ab',
    'b2b.trackingNumber': 'Sendungsnummer',
    'b2b.pickupAddress': 'Abholadresse',
    'b2b.devicePhotos': 'Gerätefotos',
    'b2b.addPhotos': 'Klicken, um Fotos hinzuzufügen',
    'b2b.additionalNotes': 'Zusätzliche Hinweise',
    'b2b.submitting': 'Wird gesendet...',
    'b2b.submitRepair': 'Reparatur registrieren',
    'b2b.brandModelRequired': 'Marke und Modell sind erforderlich',
    'b2b.noRepairFound': 'Keine Reparatur gefunden',
    'b2b.allStatus': 'Alle',
    'b2b.documents': 'Dokumente & Rechnungen',
    'b2b.documentsDesc': 'Bestätigen Sie Ihre Bestellscheine und laden Sie Ihre Rechnungen herunter',
    'b2b.pendingValidation': 'Zu bestätigende Bestellscheine',
    'b2b.enterCode': 'Geben Sie den per E-Mail erhaltenen Code ein, um jeden Bestellschein zu bestätigen.',
    'b2b.validate': 'Bestätigen',
    'b2b.invoices': 'Rechnungen',
    'b2b.noInvoices': 'Keine Rechnungen verfügbar',
    'b2b.device': 'Gerät',
    'b2b.amount': 'Betrag',
    'b2b.date': 'Datum',
    'b2b.actions': 'Aktionen',
    'b2b.paid': 'Bezahlt',
    'b2b.repairAccepted': 'Reparatur vom Personal akzeptiert',
    'b2b.repairRefused': 'Reparatur vom Personal abgelehnt',
    'b2b.orderValidated': 'Bestellschein bestätigt',
    'b2b.noPhotos': 'Keine Fotos',
    'b2b.history': 'Verlauf',
    'b2b.repairPrice': 'Reparaturpreis',
    'b2b.diagPrice': 'Diagnosepreis',
    'b2b.priceWaiting': 'Ausstehend - wird von R.E.Mobiles festgelegt',
    'b2b.createdOn': 'Erstellt am',
    'b2b.clear': 'Löschen',
    'b2b.thisMonth': 'Diesen Monat',
    'b2b.waitingReception': 'Warte auf Empfang',
    'b2b.received': 'Empfangen',
    'b2b.inProgress': 'In Bearbeitung',
    'b2b.waitingParts': 'Warte auf Teile',
    'b2b.completed': 'Abgeschlossen',
    'b2b.delivered': 'Geliefert',
    // B2B Devis
    'b2bDevis.title': 'Vor-Ort-Angebote',
    'b2bDevis.pending': 'ausstehend',
    'b2bDevis.noDevis': 'Keine Angebote',
    'b2bDevis.noDevisDesc': 'Sie haben derzeit keine Vor-Ort-Angebote.',
    'b2bDevis.travelFee': 'Anfahrtskosten',
    'b2bDevis.validationCode': 'Bestätigungscode',
    'b2bDevis.codeHint': 'Geben Sie den per E-Mail erhaltenen 6-stelligen Code ein.',
    'b2bDevis.acceptFirst': 'Bitte akzeptieren Sie zuerst das Angebot, um es bestätigen zu können.',
    'b2bDevis.payDeposit': 'Anzahlung 50% bezahlen',
    'b2bDevis.payFull': 'Gesamtbetrag bezahlen',
    'b2bDevis.payRemaining': 'Rest bezahlen',
    'b2bDevis.alreadyPaid': 'Bereits bezahlt',
    'b2bDevis.remaining': 'Restbetrag',
    'b2bDevis.invoiceDownload': 'Rechnung herunterladen',
    'b2bDevis.orderDownload': 'Bestellschein herunterladen',
    'b2bDevis.quoteDownload': 'Angebot herunterladen',
    // Admin Site Settings
    'adminSettings.title': 'Startseite',
    'adminSettings.preview': 'Vorschau',
    'adminSettings.saving': 'Wird gespeichert...',
    'adminSettings.save': 'Speichern',
    'adminSettings.saved': 'Gespeichert!',
    'adminSettings.error': 'Fehler',
    'adminSettings.heroSection': 'Hero / Kopfbereich',
    'adminSettings.mainTitle': 'Haupttitel',
    'adminSettings.subtitle': 'Untertitel',
    'adminSettings.accentColor': 'Akzentfarbe (hex)',
    'adminSettings.bgImage': 'Hintergrundbild',
    'adminSettings.change': 'Ändern',
    'adminSettings.companyInfo': 'Unternehmensinformationen',
    'adminSettings.companyName': 'Firmenname',
    'adminSettings.companyType': 'Typ (SAS, SARL...)',
    'adminSettings.capital': 'Kapital',
    'adminSettings.rcs': 'HRB',
    'adminSettings.siret': 'SIRET',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Hauptsitz',
    'adminSettings.salesPoint': 'Verkaufsstelle',
    'adminSettings.contactHours': 'Kontakt & Öffnungszeiten',
    'adminSettings.phone': 'Telefon',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'E-Mail',
    'adminSettings.googleMaps': 'Google Maps Suche',
    'adminSettings.gallery': 'Fotogalerie',
    'adminSettings.addImage': 'Bild hinzufügen',
    // Admin Database
    'adminDb.title': 'Datenbankverwaltung',
    'adminDb.subtitle': 'Export, Import und Datenverwaltung',
    'adminDb.accessDenied': 'Zugriff verweigert',
    'adminDb.adminOnly': 'Diese Seite ist Administratoren vorbehalten',
    'adminDb.clients': 'Kunden',
    'adminDb.users': 'Benutzer',
    'adminDb.repairs': 'Reparaturen',
    'adminDb.stockArticles': 'Lagerartikel',
    'adminDb.exportTitle': 'Datenbank exportieren',
    'adminDb.exportDesc': 'Alle Daten (Kunden, Benutzer, Lager, Reparaturen, Verkäufe) als JSON exportieren.',
    'adminDb.exportConfirm': 'Gesamte Datenbank exportieren?',
    'adminDb.exportBtn': 'Vollständige Datenbank exportieren',
    'adminDb.exportSuccess': 'Export erfolgreich!',
    'adminDb.exportError': 'Fehler beim Export',
    'adminDb.importTitle': 'Datenbank importieren',
    'adminDb.importDesc': 'Eine JSON-Datei importieren, um Daten wiederherzustellen oder zu migrieren.',
    'adminDb.fileSelected': 'Datei ausgewählt',
    'adminDb.uploading': 'Datei wird hochgeladen...',
    'adminDb.importDone': 'Import abgeschlossen!',
    'adminDb.importSuccess': 'Import erfolgreich!',
    'adminDb.importError': 'Fehler beim Import',
    'adminDb.importClientsBtn': 'Kunden importieren',
    'adminDb.importFullBtn': 'Vollständiger Import',
    'adminDb.importWarning': 'Der vollständige Import ersetzt vorhandene Daten',
    'adminDb.importConfirm': 'ACHTUNG: Diese Aktion ersetzt vorhandene Daten. Fortfahren?',
    'adminDb.importClientsConfirm': 'Kunden importieren? Konten werden mit der Telefonnummer als Kennung erstellt.',
    'adminDb.selectFile': 'Bitte wählen Sie eine Datei aus',
    'adminDb.selectFileClients': 'Bitte wählen Sie eine JSON-Datei mit Kunden aus',
    'adminDb.logsTitle': 'Operationsprotokoll',
    'adminDb.noLogs': 'Keine Operationen aufgezeichnet',
    // Admin B2B
    'adminB2b.title': 'B2B-Verwaltung',
    'adminB2b.home': 'Startseite',
    'adminB2b.monthlyRecap': 'Monatliche Zusammenfassung',
    'adminB2b.sending': 'Wird gesendet...',
    'adminB2b.search': 'Suchen...',
    'adminB2b.recapTitle': 'Ergebnis der monatlichen Zusammenfassung',
    'adminB2b.recapSent': 'Gesendet',
    'adminB2b.recapSkipped': 'Keine Reparaturen',
    'adminB2b.recapError': 'Fehler',
    'adminB2b.companies': 'Unternehmen',
    'adminB2b.b2bRepairs': 'B2B-Reparaturen',
    'adminB2b.paymentHistory': 'Zahlungshistorie',
    'adminB2b.all': 'Alle',
    'adminB2b.pending': 'Ausstehend',
    'adminB2b.validated': 'Bestätigt',
    'adminB2b.refused': 'Abgelehnt',
    'adminB2b.suspended': 'Gesperrt',
    'adminB2b.noCompany': 'Kein Unternehmen gefunden',
    'adminB2b.phone': 'Telefon',
    'adminB2b.siret': 'SIRET',
    'adminB2b.address': 'Adresse',
    'adminB2b.registeredOn': 'Registriert am',
    'adminB2b.validatedBy': 'Bestätigt von',
    'adminB2b.downloadKbis': 'KBIS herunterladen',
    'adminB2b.validate': 'Bestätigen',
    'adminB2b.refuse': 'Ablehnen',
    'adminB2b.suspend': 'Sperren',
    'adminB2b.confirmValidate': 'Möchten Sie dieses Unternehmen bestätigen?',
    'adminB2b.confirmRefuse': 'Möchten Sie dieses Unternehmen ablehnen?',
    'adminB2b.confirmSuspend': 'Möchten Sie dieses Unternehmen sperren?',
    'adminB2b.pendingReception': 'Warte auf Empfang',
    'adminB2b.confirmReception': 'Empfang bestätigen',
    'adminB2b.ref': 'Ref',
    'adminB2b.company': 'Unternehmen',
    'adminB2b.brandModel': 'Marke / Modell',
    'adminB2b.problem': 'Problem',
    'adminB2b.delivery': 'Lieferung',
    'adminB2b.price': 'Preis',
    'adminB2b.status': 'Status',
    'adminB2b.actions': 'Aktionen',
    'adminB2b.noRepairs': 'Keine B2B-Reparaturen gefunden',
    'adminB2b.postal': 'Post',
    'adminB2b.pickup': 'Abholung',
    'adminB2b.inStore': 'Geschäft',
    'adminB2b.changeStatus': 'Status ändern',
    'adminB2b.setPrice': 'Preis festlegen',
    'adminB2b.repairPrice': 'Reparaturpreis',
    'adminB2b.diagPrice': 'Diagnosepreis',
    'adminB2b.locked': 'Gesperrt (bezahlt)',
    'adminB2b.total': 'Gesamt',
    'adminB2b.existingInvoices': 'Vorhandene Rechnungen',
    'adminB2b.diagnostic': 'Diagnose',
    'adminB2b.repair': 'Reparatur',
    'adminB2b.combined': 'Kombiniert',
    'adminB2b.paidMethod': 'Bezahlt',
    'adminB2b.awaitingPayment': 'Ausstehend',
    'adminB2b.markPaid': 'Bezahlt',
    'adminB2b.finalize': 'Abrechnung abschließen',
    'adminB2b.backGlassBroken': 'Rückglas gebrochen',
    'adminB2b.clientPart': 'Kundenteil',
    'adminB2b.bcValidated': 'BS bestätigt',
    'adminB2b.invoiceCancelled': 'Rechnung storniert',
    'adminB2b.monthPrompt': 'Monat (1-12)? Leer lassen für den Vormonat:',
    'adminB2b.yearPrompt': 'Jahr?',
    'adminB2b.paymentMethodPrompt': 'Zahlungsart?',
    'adminB2b.filterCompany': 'Unternehmen',
    'adminB2b.filterDateStart': 'Startdatum',
    'adminB2b.filterDateEnd': 'Enddatum',
    'adminB2b.filter': 'Filtern',
    'adminB2b.clearFilter': 'Löschen',
    'adminB2b.totalCollected': 'Gesamt kassiert',
    'adminB2b.payments': 'Zahlung(en)',
    'adminB2b.payHistoryTitle': 'B2B-Zahlungshistorie',
    'adminB2b.noPayments': 'Keine B2B-Zahlungen aufgezeichnet',
    'adminB2b.invoice': 'Rechnung',
    // Users Management
    'users.title': 'Benutzerverwaltung',
    'users.count': 'Benutzer',
    'users.new': 'Neuer Benutzer',
    'users.edit': 'Benutzer bearbeiten',
    'users.username': 'Benutzername',
    'users.password': 'Passwort',
    'users.newPassword': 'Neues Passwort (leer lassen, um nicht zu ändern)',
    'users.role': 'Rolle',
    'users.roleAdmin': 'Administrator',
    'users.roleUser': 'Verkäufer',
    'users.roleTech': 'Techniker',
    'users.status': 'Status',
    'users.active': 'Aktiv',
    'users.inactive': 'Inaktiv',
    'users.createdAt': 'Erstellt am',
    'users.noUsers': 'Keine Benutzer',
    'users.accessDenied': 'Nur für Administratoren',
    'users.deleteConfirm': 'Diesen Benutzer löschen?',
    // Clients (extra keys)
    'clients.manage': 'Kundenverwaltung',
    'clients.total': 'Kunden insgesamt',
    'clients.add': 'Hinzufügen',
    'clients.noClients': 'Kein Kunde gefunden',
    'clients.type': 'Typ',
    'clients.discount': 'Rabatt',
    'clients.account': 'Konto',
    'clients.sent': 'Gesendet',
    'clients.activeAccount': 'Aktiv',
    'clients.noEmail': 'Keine E-Mail',
    'clients.editClient': 'Kunde bearbeiten',
    'clients.newClient': 'Neuer Kunde',
    'clients.company': 'Firma',
    'clients.clientType': 'Kundentyp',
    'clients.individual': 'Privatperson',
    'clients.business': 'Unternehmen',
    'clients.discountPct': 'Rabatt (%)',
    'clients.deleteConfirm': 'Diesen Kunden löschen?',
    'clients.page': 'Seite',
    // Stats
    'stats.title': 'Statistiken & Analysen',
    'stats.revenue': 'Umsatz',
    'stats.repairs': 'Reparaturen',
    'stats.b2b': 'B2B',
    'stats.clients': 'Kunden',
    'stats.back': 'Zurück',
    'stats.monthlyRevenue': 'Monatlicher Umsatz',
    'stats.revenueByType': 'Umsatz nach Typ',
    'stats.revenueByPayment': 'Umsatz nach Zahlungsart',
    'stats.totalRevenue': 'Gesamtumsatz (12 Monate)',
    'stats.repairsByStatus': 'Nach Status',
    'stats.repairsByBrand': 'Nach Marke',
    'stats.topModels': 'Top-Modelle',
    'stats.monthly': 'Monatliche Entwicklung',
    'stats.totalRepairs': 'Reparaturen gesamt',
    'stats.avgRepairTime': 'Durchschn. Dauer',
    'stats.completionRate': 'Abschlussrate',
    'stats.b2bCompanies': 'B2B-Unternehmen',
    'stats.b2bRepairs': 'B2B-Reparaturen',
    'stats.b2bRevenue': 'B2B-Umsatz',
    'stats.b2bByCompany': 'Nach Unternehmen',
    'stats.totalClients': 'Kunden gesamt',
    'stats.newThisMonth': 'Neu diesen Monat',
    'stats.withAccount': 'Mit Konto',
    'stats.clientsByType': 'Nach Typ',
    'stats.registrations': 'Monatliche Registrierungen',
    'stats.noData': 'Keine Daten',
    // Reparations (extra)
    'rep.manage': 'Reparaturverwaltung',
    'rep.noRepairs': 'Keine Reparatur gefunden',
    'rep.allStatuses': 'Alle Status',
    'rep.imei': 'IMEI / Seriennr.',
    'rep.client': 'Kunde',
    'rep.phone': 'Tel.',
    'rep.date': 'Datum',
    'rep.deposit': 'Anzahlung',
    'rep.printFiche': 'Formular drucken',
    'rep.printEtiquette': 'Etikett drucken',
    'rep.deleteConfirm': 'Diese Reparatur löschen?',
    'rep.addDeposit': 'Anzahlung hinzufügen',
    'rep.depositAmount': 'Anzahlungsbetrag',
    'rep.paymentMode': 'Zahlungsart',
    'rep.depositHistory': 'Anzahlungshistorie',
    'rep.totalDeposits': 'Anzahlungen gesamt',
    'rep.changeStatus': 'Status ändern',
    'rep.notes': 'Interne Notizen',
    'rep.sendChat': 'Nachricht senden',
    'rep.noTimeline': 'Keine Ereignisse',
    // Commandes (extra)
    'cmd.manage': 'Bestellungsverwaltung',
    'cmd.noOrders': 'Keine Bestellung gefunden',
    'cmd.allStatuses': 'Alle Status',
    'cmd.ordered': 'Bestellt',
    'cmd.received': 'Empfangen',
    'cmd.cancelled': 'Storniert',
    'cmd.status': 'Status',
    'cmd.ref': 'Ref',
    'cmd.addOrder': 'Neue Bestellung',
    'cmd.editOrder': 'Bestellung bearbeiten',
    'cmd.deleteConfirm': 'Diese Bestellung löschen?',
    // Stock (extra)
    'stock.manage': 'Lagerverwaltung',
    'stock.noItems': 'Kein Artikel gefunden',
    'stock.barcode': 'Barcode',
    'stock.reference': 'Referenz',
    'stock.alert': 'Alarm',
    'stock.lowStockAlert': 'Niedriger Lagerbestand',
    'stock.addForm': 'Artikel hinzufügen',
    'stock.editForm': 'Artikel bearbeiten',
    'stock.deleteConfirm': 'Diesen Artikel löschen?',
    // Historique
    'hist.title': 'Verkaufshistorie',
    'hist.search': 'Verkauf suchen...',
    'hist.noSales': 'Kein Verkauf gefunden',
    'hist.ref': 'Ref.',
    'hist.client': 'Kunde',
    'hist.amount': 'Betrag',
    'hist.payment': 'Zahlung',
    'hist.date': 'Datum',
    'hist.articles': 'Artikel',
    'hist.refund': 'Erstatten',
    'hist.refundConfirm': 'Diesen Verkauf erstatten?',
    // Paiements
    'pay.title': 'Online-Zahlungen',
    'pay.search': 'Suchen...',
    'pay.noPayments': 'Keine Zahlung gefunden',
    'pay.ref': 'Referenz',
    'pay.client': 'Kunde',
    'pay.amount': 'Betrag',
    'pay.status': 'Status',
    'pay.date': 'Datum',
    'pay.type': 'Typ',
    // Caisse
    'caisse.title': 'Kassenhistorie',
    'caisse.noCaisse': 'Keine Kasse gefunden',
    'caisse.openedBy': 'Geöffnet von',
    'caisse.openingAmount': 'Eröffnungsbetrag',
    'caisse.closingAmount': 'Schlussbetrag',
    'caisse.sales': 'Verkäufe',
    'caisse.openDate': 'Öffnung',
    'caisse.closeDate': 'Schließung',
    // Notes
    'notes.title': 'Notizen',
    'notes.new': 'Neue Notiz',
    'notes.noNotes': 'Keine Notizen',
    'notes.deleteConfirm': 'Diese Notiz löschen?',
    // Etiquettes
    'labels.title': 'Etiketten',
    'labels.search': 'Suchen...',
    'labels.print': 'Drucken',
    'labels.selectAll': 'Alle auswählen',
    'labels.noLabels': 'Keine Etiketten',
    // Calcul Prix
    'calc.title': 'Preisberechnung',
    'calc.searchDevice': 'Gerät suchen...',
    'calc.selectRepair': 'Reparatur auswählen',
    'calc.generateQuote': 'Angebot erstellen',
    'calc.generateInvoice': 'Rechnung erstellen',
    // Boutique
    'boutique.title': 'Shop-Bestellungen',
    'boutique.noOrders': 'Keine Bestellungen',
    'boutique.orderRef': 'Bestellnr.',
    'boutique.clientName': 'Kunde',
    'boutique.total': 'Gesamt',
    'boutique.status': 'Status',
    // Chat
    'chat.title': 'Nachrichten',
    'chat.noConversations': 'Keine Gespräche',
    'chat.typeMessage': 'Nachricht eingeben...',
    // Brands & Models
    'brands.title': 'Marken & Modelle',
    'brands.addBrand': 'Marke hinzufügen',
    'brands.addModel': 'Modell hinzufügen',
    'brands.noBrands': 'Keine Marken',
    'brands.deleteConfirm': 'Diese Marke löschen?',
    // Remcaches
    'remcaches.title': 'Cache-Rücksetzungen',
    'remcaches.noItems': 'Keine Artikel',
    // Close Caisse
    'closeCaisse.title': 'Kassenschluss',
    'closeCaisse.countCoins': 'Bargeld zählen',
    'closeCaisse.theoreticalTotal': 'Theoretischer Betrag',
    'closeCaisse.actualTotal': 'Tatsächlicher Betrag',
    'closeCaisse.difference': 'Differenz',
    'closeCaisse.close': 'Kasse schließen',
    'closeCaisse.closing': 'Schließung...',
    // Client Passwords
    'clientPwd.title': 'Kundenpasswörter',
    'clientPwd.search': 'Kunde suchen...',
    'clientPwd.noClients': 'Kein Kunde gefunden',
    'clientPwd.generatePin': 'PIN generieren',
    'clientPwd.sendByEmail': 'Per E-Mail senden',
    // B2B Payments
    'b2bPay.title': 'B2B-Zahlungen',
    'b2bPay.noPayments': 'Keine Zahlungen',
    // Reparation Form
    'repForm.title': 'Gerät hinzufügen',
    'repForm.editTitle': 'Reparatur bearbeiten',
    'repForm.brand': 'Marke',
    'repForm.model': 'Modell',
    'repForm.imei': 'IMEI / Seriennr.',
    'repForm.lockCode': 'Entsperrcode',
    'repForm.problem': 'Festgestelltes Problem',
    'repForm.client': 'Kunde',
    'repForm.technician': 'Zugewiesener Techniker',
    'repForm.price': 'Reparaturpreis',
    'repForm.submit': 'Speichern',
    'repForm.submitting': 'Wird gespeichert...',
    'sumup.acceptOnlinePayment': 'Online-Zahlung akzeptieren (SumUp)', 'sumup.acceptOnlinePaymentDesc': 'Der Kunde kann einen SumUp-Zahlungslink anfordern', 'sumup.requestLink': 'SumUp-Zahlungslink anfordern', 'sumup.requestSent': 'Anfrage gesendet! Sie erhalten den Link per E-Mail.', 'sumup.alreadyRequested': 'Anfrage bereits in Bearbeitung.', 'sumup.onlinePayment': 'SumUp Online-Zahlung', 'sumup.receiveLink': 'Sicheren Zahlungslink per E-Mail erhalten', 'sumup.linkRequested': 'Link angefordert', 'sumup.pendingRequests': 'SumUp-Linkanfragen', 'sumup.pending': 'ausstehend', 'sumup.pasteLinkHere': 'SumUp-Link hier einfügen...', 'sumup.send': 'Senden', 'sumup.linkSent': 'SumUp-Link per E-Mail an den Kunden gesendet!',
  };

export default de;
